import {FC} from "react";
import {CloseIconButton, CloseIconContainer, FileElement, FileIcon, FileListContainer, FileName} from "./styles";
import {useSelector} from "react-redux";
import {selectUploadFiles} from "../../../selectors/upload";
import CancelIcon from '@mui/icons-material/Cancel';
import {getStoreUtils} from "../../../store/utils";
import {setUploads} from "../../../ducks/upload";
export const FileList: FC = () => {
    const files = useSelector(selectUploadFiles);
    const { dispatch } = getStoreUtils();

    return files.length !== 0 ?  <FileListContainer>
        {files.map(({fileName, id}) => <FileElement
            onClick={() => {
                dispatch(setUploads(files.filter((file) => file.id !== id)));
            }}
            title={fileName}
        >
            <CloseIconContainer>
                <CloseIconButton>
                    <CancelIcon/>
                </CloseIconButton>
            </CloseIconContainer>
            <FileIcon/>
            <FileName>
                {fileName}
            </FileName>
        </FileElement>)}
    </FileListContainer> : null;
}
